import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineFormatListAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      clipPath="url(#a)"
    >
      <path d="M11.937 9.05v5.775M9.05 11.938h5.775M1.175 1.175h1.05m12.6 0h-10.5M1.175 4.85h1.05m12.6 0h-10.5M1.175 8.525h1.05m6.3 0h-4.2" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineFormatListAdd;
